module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [(_vm.objUserNotifications.users == null) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.objUserNotifications.users != null) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.objUserNotifications.users != null) ? _c('v-data-table', {
    staticClass: "elevation-1 linkTableMedium",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.objUserNotifications.users,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.active == 1 && props.item.description != 'User Confirmation Email' && props.item.description != 'Email Template' && !props.item.description.includes('RFC')) ? _c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "70%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.get_sms),
            callback: function($$v) {
              _vm.$set(props.item, "get_sms", $$v)
            },
            expression: "props.item.get_sms"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.get_email),
            callback: function($$v) {
              _vm.$set(props.item, "get_email", $$v)
            },
            expression: "props.item.get_email"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.get_push),
            callback: function($$v) {
              _vm.$set(props.item, "get_push", $$v)
            },
            expression: "props.item.get_push"
          }
        })], 1)]) : _vm._e()]
      }
    }], null, false, 3321171410)
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditNotifications()
      }
    }
  }, [_vm._v("Save")])], 1)])])], 1)], 1)
},staticRenderFns: []}